export const datalakeStorageAccountOptions = [
    'chevrondatalake',
    'chevrondatalakedev',
    'chevrondatalaketest',
    'chevrondatalakeaue1',
    'chevrondatalakeeuw1',
    'chevrondatalakeaue1dev',
    'chevrondatalakeeuw1dev',
    'chevrondatalakeaue1test',
    'chevrondatalakeeuw1test',
] as const;

export const datalakeContainerOptions = ['raw', 'refined', 'produced'] as const;
